import {Component, OnInit, ViewChild} from '@angular/core';
import {ModalComponent} from '@components/modal/modal.component';
import {SpecialistViewInterface} from '@interfaces/specialist.interface';

@Component({
    selector: 'app-specialist-edit-modal',
    templateUrl: 'specialist-edit-modal.component.html'
})

export class SpecialistEditModalComponent implements OnInit {
    @ViewChild(ModalComponent) private modal: ModalComponent;
    public specialist: SpecialistViewInterface;

    constructor() {
    }

    ngOnInit() {
    }

    show() {
        this.modal.open();
    }

    onModalClose() {
        /**
         * Метод будет переопределяться в компонентах, которые используют данный компонент динамически
         */
    }
}
